import React from 'react';
// import Loadable from 'react-loadable';
import { Route } from 'react-router-dom';
// import { RawLoader } from '../components/loading/loading';
import * as documentTypes from '../constants/documentTypes/documentTypes';
import INavigationItem from '../interfaces/navigation/navigationItem';
import Article from '../pages/articles/article';
import Articles from '../pages/articles/articles';
import AvailableJobs from '../pages/availableJobs';
import ChangeDestination from '../pages/changeDestination';
import CompanyDebitForm from '../pages/companyDebitForm';
import Contact from '../pages/contact';
import ContentSite from '../pages/contentSite';
import CustomerOpinions from '../pages/customerOpinions';
import DamageReport from '../pages/damageReport';
import Deliverytime from '../pages/deliverytime';
import Frontpage from '../pages/frontpage';
import GeneralPostInfo from '../pages/generalPostInfo';
import HomeDelivery from '../pages/homeDelivery';
import Inquiry from '../pages/inquiry';
import MyShipments from '../pages/myShipments';
import MyShipmentsForgotPassword from '../pages/myShipmentsForgotPassword/myShipmentsForgotPassword';
import myShipmentsLandingPagesEmail from '../pages/myShipmentsLandingPagesEmail/myShipmentsLandingPagesEmail';
import myShipmentsLandingPagesResetPassword from '../pages/myShipmentsLandingPagesResetPassword';
import MyShipmentsLandingPagesSocialId from '../pages/myShipmentsLandingPagesSocialId/myShipmentsLandingPagesSocialId';
import MyShipmentsRecipients from '../pages/myShipmentsRecipients/myShipmentsRecipients';
import MyShipmentsRefund from '../pages/myShipmentsRefund/myShipmentsRefund';
import MyShipmentsRegisterShipment from '../pages/myShipmentsRegisterShipment';
import MyShipmentsRegistration from '../pages/myShipmentsRegistration/myShipmentsRegistration';
import MyShipmentsSettings from '../pages/myShipmentsSettings/myShipmentsSettings';
import MyShipmentsShipment from '../pages/myShipmentsShipment/myShipmentsShipment';
import NewsletterForm from '../pages/newsletterForm';
import NotFound from '../pages/notFoundV2';
import OpeningHours from '../pages/openingHours/openingHours';
import PostboxDelivery from '../pages/postboxDelivery';
import RegisterShipment from '../pages/registerShipment';
import RegisterShipmentCalculator from '../pages/registerShipmentCalculator';
import Search from '../pages/search';
import SendReceipt from '../pages/sendReceipt';
import SendReceiptMultistep from '../pages/sendReceiptMultistep';
import ShipmentCalculator from '../pages/shipmentCalculator';
import Styleguide from '../pages/styleguide';
import SubRoute from '../pages/subRoute';
import TrackShipment from '../pages/trackShipment';

const mapper = {
	[documentTypes.article]: Article,
	[documentTypes.articles]: Articles,
	[documentTypes.articleYear]: Articles,
	[documentTypes.availableJobs]: AvailableJobs,
	[documentTypes.companyDebitForm]: CompanyDebitForm,
	[documentTypes.contact]: Contact,
	[documentTypes.contentSite]: ContentSite,
	[documentTypes.customerOpinions]: CustomerOpinions,
	[documentTypes.damageReport]: DamageReport,
	[documentTypes.deliverytime]: Deliverytime,
	[documentTypes.frontpage]: Frontpage,
	[documentTypes.generalPostInfo]: GeneralPostInfo,
	[documentTypes.homeDelivery]: HomeDelivery,
	[documentTypes.myShipmentsRefund]: MyShipmentsRefund,

	[documentTypes.inquiry]: Inquiry,
	[documentTypes.menuGroup]: SubRoute,
	[documentTypes.menuSubGroup]: SubRoute,
	[documentTypes.myShipments]: MyShipments,
	[documentTypes.myShipmentsRegistration]: MyShipmentsRegistration,
	[documentTypes.myShipmentsForgotPassword]: MyShipmentsForgotPassword,
	[documentTypes.newsletterSubscription]: NewsletterForm,
	[documentTypes.openingHours]: OpeningHours,
	[documentTypes.postboxDelivery]: PostboxDelivery,
	[documentTypes.registerShipment]: RegisterShipment,
	[documentTypes.registerShipmentCalculator]: RegisterShipmentCalculator,
	[documentTypes.search]: Search,
	[documentTypes.sendReceipt]: SendReceipt,
	[documentTypes.sendReceiptMultistep]: SendReceiptMultistep,
	[documentTypes.shipmentCalculator]: ShipmentCalculator,
	[documentTypes.styleguide]: Styleguide,
	[documentTypes.trackShipment]: TrackShipment,
	[documentTypes.myShipmentsSocialIdVerification]: MyShipmentsLandingPagesSocialId,
	[documentTypes.myShipmentsResetPassword]: myShipmentsLandingPagesResetPassword,
	[documentTypes.myShipmentsEmailVerification]: myShipmentsLandingPagesEmail,
	[documentTypes.myShipmentsSettings]: MyShipmentsSettings,
	[documentTypes.myShipmentRecipients]: MyShipmentsRecipients,
	[documentTypes.myShipmentsShipment]: MyShipmentsShipment,
	[documentTypes.myShipmentsRegisterShipment]: MyShipmentsRegisterShipment,
	[documentTypes.postboxFull]: ChangeDestination,
};

// const urlMapper = {
// 	[documentTypes.article]: '../pages/articles/article',
// 	[documentTypes.articles]: '../pages/articles/articles',
// 	[documentTypes.articleYear]: '../pages/articles/articles',
// 	[documentTypes.availableJobs]: '../pages/availableJobs',
// 	[documentTypes.companyDebitForm]: '../pages/companyDebitForm',
// 	[documentTypes.contact]: '../pages/contact',
// 	[documentTypes.contentSite]: '../pages/contentSite',
// 	[documentTypes.customerOpinions]: '../pages/customerOpinions',
// 	[documentTypes.damageReport]: '../pages/damageReport',
// 	[documentTypes.deliverytime]: '../pages/deliverytime',
// 	[documentTypes.evaluateImportDutyCharges]: '../pages/evaluateImportDutyCharges',
// 	[documentTypes.event]: '../pages/events/event',
// 	[documentTypes.events]: '../pages/events',
// 	[documentTypes.frontpage]: '../pages/frontpage',
// 	[documentTypes.generalPostInfo]: '../pages/generalPostInfo',
// 	[documentTypes.homeDelivery]: '../pages/homeDelivery',
// 	[documentTypes.inquiry]: '../pages/inquiry',
// 	[documentTypes.menuGroup]: '../pages/subRoute',
// 	[documentTypes.menuSubGroup]: '../pages/subRoute',
// 	[documentTypes.newsletterSubscription]: '../pages/newsletterForm',
// 	[documentTypes.openingHours]: '../pages/openingHours',
// 	[documentTypes.postboxPromo]: '../pages/postboxPromo',
// 	[documentTypes.priceListGroup]: '../pages/priceListGroup',
// 	[documentTypes.registerShipment]: '../pages/registerShipment',
// 	[documentTypes.registerShipmentCalculator]: '../pages/registerShipmentCalculator',
// 	[documentTypes.search]: '../pages/search',
// 	[documentTypes.sendReceipt]: '../pages/sendReceipt',
// 	[documentTypes.shipmentCalculator]: '../pages/shipmentCalculator',
// 	[documentTypes.styleguide]: '../pages/styleguide',
// 	[documentTypes.trackShipment]: '../pages/trackShipment',
// };

const getRouteTemplateFromType = type => {
	const result = mapper[type] || NotFound;

	return result;
};

// const getRouteForComponent = type => {
// 	const result = urlMapper[type] || '../pages/notFound';
// 	return result;
// };

const mappedRoutes = (routes: INavigationItem[]) => {
	return routes.map(route => (
		<Route
			exact
			//path={[`/${route.Id}.aspx`, route.Url]}
			path={[route.Url, `/${route.Id}.aspx`, `/${route.Id}`].filter(Boolean)}
			key={route.Id}
			id={route.Id}
			render={routeProps => {
				const Component = getRouteTemplateFromType(route.Type);
				return <Component {...routeProps} componentId={route.Id} />;

				// const componentUrl = getRouteForComponent(route.Type);
				// console.log(componentUrl);
				// const LoadableComponent = Loadable({
				// 	loader: () => import('../pages/frontpage'),
				// 	loading: RawLoader,
				// });
				// return <LoadableComponent {...routeProps} componentId={route.Id} />;
			}}
		/>
	));
};

export default mappedRoutes;
